<template>
  <div :class="css" v-if="show && !value">
    <v-icon i v-if="icon">{{icon}}</v-icon>
    <span v-if="label"><b>{{label}}</b><br></span>
    <span v-else><b v-if="type">{{type}}</b><br></span>
    <span v-for="(tag, ii) in list" v-bind:key="ii" :class="{'tag-item': true, comma:true, highlight: dark(tag)}">
        <!--span v-if="percentage"><md-progress-bar md-mode="determinate" :md-value="percentage"></md-progress-bar>{{percentage}}%</span-->
        {{tag.name}} {{unit}}
    </span>
  </div>
  <div :class="css" v-else>
    <v-icon i v-if="icon">{{icon}}</v-icon>
    <span><b v-if="value">{{value}}</b>{{unit}}</span><br>
    <span v-if="label">{{label}}</span>
  </div>
</template>

<script>
export default {
  props: ["type", "tags", "icon", "showIfEmpty", "percentage", "selected", "unit", "value","label"],
  computed: {
    list () {
      return this.tags.filter(t => t.type == this.type)
    },
    show () {
      if (this.showIfEmpty) return true
      if (!this.tags || this.list.length == 0) return false
      return true
    },
    css (){
      var c = {'md-tag': true, "mb-2": true}
      if (this.icon) c['image-tag'] = true
      if (this.class) c[this.class] = true
      if (this.value) c['large'] = true
      //c['icon-' + this.icon] = true
      return c
    },
    iconCss (){
      var c = {'md-icon': true, 'md-icon-font' : true, 'md-theme-default' : true}
      return c
    }
  },
  methods: {
     color(tag) {
       if (!this.selected) return
      if (this.selected.indexOf(tag.name)>-1) return "primary"
    },
    dark(tag) {
      //console.log(this.selected,tag.name, this.selected.indexOf(tag.name))
      if (!this.selected) return false
      if (this.selected.indexOf(tag.name)>-1) return true
      return false
    },
  }
}
</script>

<style lang="css">
  .md-tag {
      font-size: 0.7em!important;
    line-height: 1.2em!important;
    text-align: left;
    cursor: pointer;
  }
  .md-tag.image-tag {
    padding-left: 30px;
  }
  .md-tag i{
    position:absolute;
    color: #5595c9!important;
    margin-left:-25px;
    margin-top: -2px;
  }
  .md-tag.icon-check i ,
  .md-tag.icon-minimize i{
    margin-top: -7px;
    font-size: 1.5em!important;
  }
  .md-tag.icon-minimize i{
    margin-top: -12px;
    display:none;
  }
  .md-tag.icon-minimize{
    position:absolute;
  opacity:0;
  overflow:hidden;
  transition: 1.15s slideIn ease-out
  }
 .md-tag.icon-minimize .md-tag.icon-minimize i{
   display:block
 }
.md-expand-active .md-tag.icon-minimize{
  position:relative;
  height:auto;
  opacity:1;
}
 .md-tag b {
  text-transform: uppercase;
  color: #5595c9;
  letter-spacing: 2px;
  margin-bottom: 2px;
}

.md-tag.large {
  line-height: 2em!important;
  text-align: left;
}
.md-tag.large b{
  font-size: 2.5em;
}
@keyframes slideIn {
    0%   {top: 0px;}
    25%  {position:relative;}
    50%  {height:20px}
    75%  {height:30px}
    100% {height: auto;}
}
.comma:not(:last-of-type):after {
  content: ", ";
  font-weight: 300;
}
.comma:nth-last-of-type(2):before {
  content: none;
}
.comma:nth-last-of-type(2):after {
  content: " en ";
  font-weight: 300;
}
.tag-item.highlight{
  font-weight:bold!important;
}
</style>
